import React from 'react';

import { accentColors } from 'data/accentColors';

import './index.scss';

const isPreset = (color) =>
  accentColors.some(({ value }) => value === color);

const ColorPicker = ({ selectedColor, onSelect }) => (
  <div className="color-picker" role="radiogroup" aria-label="Accent color">
    {accentColors.map(({ name, value }) => (
      <button
        key={value}
        type="button"
        className={`color-swatch${
          selectedColor === value ? ' color-swatch-active' : ''
        }`}
        style={{ backgroundColor: value }}
        aria-label={name}
        aria-pressed={selectedColor === value}
        onClick={() => onSelect(value)}
      />
    ))}
    <label
      className={`color-swatch color-swatch-custom${
        !isPreset(selectedColor) ? ' color-swatch-active' : ''
      }`}
      style={!isPreset(selectedColor) ? { backgroundColor: selectedColor } : undefined}
      aria-label="Custom color"
    >
      <input
        type="color"
        value={selectedColor}
        onChange={(e) => onSelect(e.target.value)}
      />
    </label>
  </div>
);

export default ColorPicker;
